import { render, staticRenderFns } from "./Action_confirm_value.vue?vue&type=template&id=35f739b4&scoped=true&"
import script from "./Action_confirm_value.vue?vue&type=script&lang=js&"
export * from "./Action_confirm_value.vue?vue&type=script&lang=js&"
import style0 from "./Action_confirm_value.vue?vue&type=style&index=0&id=35f739b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35f739b4",
  null
  
)

export default component.exports